<app-pagetitle title="Processo de Assinaturas" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <div class="invoice-title">
                    <div class="d-flex align-items-start">
                        <div class="flex-grow-1">
                            <div class="mb-4">
                                <img src="assets/images/logo-sm.svg" alt="" height="24"><span
                                    class="logo-txt">Minia</span>
                            </div>
                        </div>
                        <div class="flex-shrink-0">
                            <div class="mb-4">
                                <h4 class="float-end font-size-16">Invoice # 12345</h4>
                            </div>
                        </div>
                    </div>

                    <p class="mb-1">1874 County Line Road City, FL 33566</p>
                    <p class="mb-1"><i class="mdi mdi-email align-middle me-1"></i> abc&#64;123.com</p>
                    <p><i class="mdi mdi-phone align-middle me-1"></i> 012-345-6789</p>
                </div>
                <hr class="my-4">
                <div class="row">
                    <div class="col-sm-6">
                        <div>
                            <h5 class="font-size-15 mb-3">Billed To:</h5>
                            <h5 class="font-size-14 mb-2">Richard Saul</h5>
                            <p class="mb-1">1208 Sherwood Circle
                                Lafayette, LA 70506</p>
                            <p class="mb-1">RichardSaul&#64;rhyta.com</p>
                            <p>337-256-9134</p>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div>
                            <div>
                                <h5 class="font-size-15">Order Date:</h5>
                                <p>February 16, 2020</p>
                            </div>

                            <div class="mt-4">
                                <h5 class="font-size-15">Payment Method:</h5>
                                <p class="mb-1">Visa ending **** 4242</p>
                                <p>richards&#64;email.com</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="py-2 mt-3">
                    <h5 class="font-size-15">Order summary</h5>
                </div>
                <div class="p-4 border rounded">
                    <div class="table-responsive">
                        <table class="table table-nowrap align-middle mb-0">
                            <thead>
                                <tr>
                                    <th style="width: 70px;">No.</th>
                                    <th>Item</th>
                                    <th class="text-end" style="width: 120px;">Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="row">01</th>
                                    <td>
                                        <h5 class="font-size-15 mb-1">Minia</h5>
                                        <p class="font-size-13 text-muted mb-0">Bootstrap 5 Admin Dashboard </p>
                                    </td>
                                    <td class="text-end">$499.00</td>
                                </tr>

                                <tr>
                                    <th scope="row">02</th>
                                    <td>
                                        <h5 class="font-size-15 mb-1">Skote</h5>
                                        <p class="font-size-13 text-muted mb-0">Bootstrap 5 Admin Dashboard </p>
                                    </td>
                                    <td class="text-end">$499.00</td>
                                </tr>

                                <tr>
                                    <th scope="row" colspan="2" class="text-end">Sub Total</th>
                                    <td class="text-end">$998.00</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2" class="border-0 text-end">
                                        Tax</th>
                                    <td class="border-0 text-end">$12.00</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2" class="border-0 text-end">Total</th>
                                    <td class="border-0 text-end">
                                        <h4 class="m-0">$1010.00</h4>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="d-print-none mt-3">
                    <div class="float-end">
                        <a href="javascript:window.print()" class="btn btn-success waves-effect waves-light me-1"><i
                                class="fa fa-print"></i></a>
                        <a routerLink="/apps/invoice-detail"
                            class="btn btn-primary w-md waves-effect waves-light">Send</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- <div class="card col-4">
    <div class="card-header">

    </div>
    <div class="card-body d-flex">
        <div class="activity-icon avatar-md">
            <span
                class="avatar-title bg-warning-subtle text-warning rounded-circle">
                <i class="bx bx-highlight font-size-24"></i>
            </span>
        </div>
        <div class="timeline-list-item ms-3">
            <div class="d-flex">
                <div class="flex-grow-1 overflow-hidden me-4">
                    <h5 class="font-size-14 mb-1">24/05/2021 18:24:56</h5>
                    <!-- <p class="text-truncate text-muted font-size-13">Aguardando assinatura</p> 
                    <span class="badge badge-soft-warning text-warning">PENDENTE DE
                        ASSINATURA</span>
                </div>
                <div>
                    <div class="flex-shrink-0 text-end me-3">
                        <h6 class="mb-1">Ações</h6>
                    </div>
    
                    <div class="flex-shrink-0 text-end">
                        <div class="dropdown">
                            <a class="text-muted dropdown-toggle font-size-24"
                                role="button" data-bs-toggle="dropdown"
                                aria-haspopup="true">
                                <i class="mdi mdi-dots-vertical"></i>
                            </a>
    
                            <div class="dropdown-menu dropdown-menu-end">
                                <a class="dropdown-item" href="#">Action</a>
                                <a class="dropdown-item" href="#">Another action</a>
                                <a class="dropdown-item" href="#">Something else
                                    here</a>
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item" href="#">Separated link</a>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</div>
<div class="col-xl-4">
    <div class="card">
        <div class="card-header align-items-center d-flex">
            <h4 class="card-title mb-0 flex-grow-1">Status atual:</h4>
        </div><!-- end card header 

        <div class="card-body px-0">
            <div class="px-3 simplebar-scrollable-y" data-simplebar="init" style="max-height: 352px;">
                <div class="simplebar-wrapper" style="margin: 0px -16px;">
                    <div class="simplebar-height-auto-observer-wrapper">
                        <div class="simplebar-height-auto-observer"></div>
                    </div>
                    <div class="simplebar-mask">
                        <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                            <div class="simplebar-content-wrapper" tabindex="0" role="region"
                                aria-label="scrollable content" style="height: auto; overflow: hidden scroll;">
                                <div class="simplebar-content" style="padding: 0px 16px;">
                                    <ul class="list-unstyled activity-wid mb-0">

                                        <li class="activity-list activity-border">
                                            <div class="activity-icon avatar-md">
                                                <span
                                                    class="avatar-title bg-warning-subtle text-warning rounded-circle">
                                                    <i class="bx bx-highlight font-size-24"></i>
                                                </span>
                                            </div>
                                            <div class="timeline-list-item">
                                                <div class="d-flex">
                                                    <div class="flex-grow-1 overflow-hidden me-4">
                                                        <h5 class="font-size-14 mb-1">24/05/2021 18:24:56</h5>
                                                        <!-- <p class="text-truncate text-muted font-size-13">Aguardando assinatura</p>
                                                        <span class="badge badge-soft-warning text-warning">PENDENTE DE
                                                            ASSINATURA</span>
                                                    </div>
                                                    <div class="flex-shrink-0 text-end me-3">
                                                        <h6 class="mb-1">+0.5 BTC</h6>
                                                        <div class="font-size-13">$178.53</div>
                                                    </div>

                                                    <div class="flex-shrink-0 text-end">
                                                        <div class="dropdown">
                                                            <a class="text-muted dropdown-toggle font-size-24"
                                                                role="button" data-bs-toggle="dropdown"
                                                                aria-haspopup="true">
                                                                <i class="mdi mdi-dots-vertical"></i>
                                                            </a>

                                                            <div class="dropdown-menu dropdown-menu-end">
                                                                <a class="dropdown-item" href="#">Action</a>
                                                                <a class="dropdown-item" href="#">Another action</a>
                                                                <a class="dropdown-item" href="#">Something else
                                                                    here</a>
                                                                <div class="dropdown-divider"></div>
                                                                <a class="dropdown-item" href="#">Separated link</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="simplebar-placeholder" style="width: 386px; height: 438px;"></div>
                </div>
                <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;">
                    <div class="simplebar-scrollbar" style="width: 0px; display: none;"></div>
                </div>
                <div class="simplebar-track simplebar-vertical" style="visibility: visible;">
                    <div class="simplebar-scrollbar"
                        style="transform: translate3d(0px, 0px, 0px); display: block;"></div>
                </div>
            </div>
        </div>
        <!-- end card body 
    </div>
    <!-- end card 
</div> -->